import React, { useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import SubHeader from "../SubComp/SubHeader/SubHeader";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Artist.css";
import axios from "axios";
import ArtistData from "./ArtistData";

const Artist = () => {
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    axios.get("https://skabelse.herokuapp.com/artist/").then((res) => {
      setArtists(res.data);
    });
  }, []);
  
console.log(artists)
  return (
    <div className="all_artist">
      <Header />
      <SubHeader title="Artist" text="Artist" width="container" />
      {/* topHeading */}
      <div className="topHeading my-5">
        <div className="container">
          <div className="d-flex flex-wrap">
            <div className="w60 cl-lightGrey ">
              <p>
                Explore an unparalleled artwork selection by over 100K artists
                from around the world, including paintings, photography,
                sculpture, drawings, collage, and limited editions.
              </p>
            </div>
            <div className="w20 ms-auto searchbar">
              <div class="input-group h-100 bg-transparent px-2">
                <div class="border-0 bg-transparent d-flex align-items-center">
                  <button type="button" class="btn border-0">
                    <FontAwesomeIcon className="cl-pm" icon={faSearch} />
                  </button>
                </div>
                <input
                  type="search"
                  class="form-control  border-0 bg-transparent text-white"
                  placeholder="Search Artist"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* artist content */}
      <div className="container">
        <div className="artistCard ">
          <div className="row justify-content-center">
            
              {artists.map((artist) => (
                <ArtistData
                  key={artist.id}
                  artist={artist}
                ></ArtistData>
              ))}
           
            
          </div>
        </div>
        
      </div>
      <Footer displayNone="d-none" />
    </div>
  );
};

export default Artist;
